import styled from 'styled-components'

export const Container = styled.div `
  height: 100%;
  width: 100%;
`

export const TableContainer = styled.div`
  padding-top: ${({enableExportMenu}) => enableExportMenu ? "40px" : "unset"};
  position: relative;
  width: ${({width}) => width};
  height: ${({height}) => height};
  border: ${({border}) => border};
  border-radius: ${({borderRadius}) => borderRadius};
  background-color: ${({backgroundColor}) => backgroundColor};
  overflow-x: auto;
  ${({freezeFirstColumn}) => freezeFirstColumn && `
    overflow-x: unset;
  `}
  .table {
    border-radius: ${({borderRadius}) => borderRadius};
    min-width: fit-content !important;

    ${props => props?.freezeFirstColumn && `
      min-width: unset !important;
      overflow: auto;
      height: ${props?.tableHeight};
      &.sticky {
        .thead,
        .tfoot {
          position: sticky;
          z-index: 5;
          min-width: fit-content;
        }

        .thead {
          top: 0;
        }

        .tfoot {
          bottom: 0;
        }

        .tbody {
          position: relative;
          z-index: 0;
        }

        [data-sticky-td] {
          position: sticky;
        }
        
        [data-sticky-last-left-td] {
          border-right: ${props?.displayBodyCellSeparator ? props?.bodyCellSeparator : ""} !important;
        }
      }

      .thead {
        min-width: fit-content !important;
        .th{
          background-color: ${props?.headBackgroundColor};
        }
      }

      .tbody {
        min-width: fit-content !important;
        height: unset !important;
        overflow: unset;

        .tr {
          &:nth-child(even) {
            .td{
              background-color: ${props?.bodyEvenRowBackgroundColor};
            }
          }
          .td {
            background-color: ${props?.bodyOddRowBackgroundColor};
          }
        }
      }

      .tfoot {
        min-width: fit-content !important;
        .td {
          background-color: ${props?.footBackgroundColor};
        }
      }
    `}
  }
  .thead {
    display: flex;
    background-color: ${({headBackgroundColor}) => headBackgroundColor};
    color: ${({headColor}) => headColor};
    ${({headFontSize}) => headFontSize && `
      font-size: ${headFontSize};
    `}
    ${({headFontSize, headHeight}) => !headFontSize && `
      height: ${headHeight};
    `}
    border: ${({headBorder}) => headBorder};
    border-radius: ${({headBorderRadius}) => headBorderRadius};
    .th {
      display: flex;
      padding: 0 5px;
      min-width: 150px !important;
      flex-direction: column;
      justify-content: ${({headCellJustifyContentIfFilterEnable}) => headCellJustifyContentIfFilterEnable ? "flex-end" : "center"};
      align-items: ${({headCellJustifyContent}) => headCellJustifyContent};
      border-left: ${({displayHeadCellSeparator, headCellSeparator}) => displayHeadCellSeparator ? headCellSeparator : ""};
      &:first-of-type {
        border-left: none;
      }
    }
  }
  .tbody {
    display: flex;
    flex-direction: column;
    background-color: ${({bodyBackgroundColor}) => bodyBackgroundColor};
    height: ${({bodyHeight}) => bodyHeight};
    overflow-y: auto;
    overflow-x: hidden;
    .tr {
      border-top: ${({displayBodyRowSeparator, bodyRowSeparator}) => displayBodyRowSeparator ? bodyRowSeparator : ""};
      background-color: ${({bodyOddRowBackgroundColor}) => bodyOddRowBackgroundColor};
      &:nth-child(even) {
        background-color: ${({bodyEvenRowBackgroundColor}) => bodyEvenRowBackgroundColor};
      }
      &:first-of-type {
        border-top: none;
      }
      border-radius: ${({bodyRowBorderRadius}) => bodyRowBorderRadius};
    }
    .td {
      min-height: ${({bodyCellHeight}) => bodyCellHeight};
      display: flex;
      padding: 0 5px;
      overflow-wrap: anywhere;
      min-width: 150px !important;
      justify-content: ${({bodyCellJustifyContent}) => bodyCellJustifyContent};
      align-items: ${({bodyCellAlignItems}) => bodyCellAlignItems};
      border-left: ${({displayBodyCellSeparator, bodyCellSeparator}) => displayBodyCellSeparator ? bodyCellSeparator : ""};
      &:first-of-type {
        border-left: none;
      }
    }
  }
  .tfoot {
    display: flex;
    background-color: ${({footBackgroundColor}) => footBackgroundColor};
    color: ${({footColor}) => footColor};
    height: ${({footHeight}) => footHeight};
    border: ${({headBorder}) => headBorder};
    border-radius: ${({headBorderRadius}) => headBorderRadius};
    .td {
      display: flex;
      padding: 0 5px;
      min-width: 150px !important;
      flex-direction: column;
      justify-content: ${({footCellJustifyContent}) => footCellJustifyContent};
      align-items: ${({footCellAlignItems}) => footCellAlignItems};
      border-left: ${({displayFootCellSeparator, footCellSeparator}) => displayFootCellSeparator ? footCellSeparator : ""};
      font-weight: ${({footCellFontWeight}) => footCellFontWeight};
      &:first-of-type {
        border-left: none;
      }
    }
  }
`

export const FilterContainer = styled.div `
  width: 100%;
  padding: 5px 0 5px 0;
`

export const HeaderContent = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  text-align: center;
  .fas {
    margin-left: 5px;
    color: #fff;
  }
`

export const FooterContainer = styled.div `
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  height: 50px;
  width: 100%;
`

// PAGINATION

export const PaginationBtnNumberPage = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 30px;
  background-color: ${({color, selected}) => selected ? color : "transparent"};
  color: ${({color, selected}) => selected ? '#fff' : color};
  font-size: 17px;
  transition: 0.2s;
  cursor: pointer;
  user-select: none;
  &:hover {
    background-color: ${({color}) => color};
    color: #fff;
  }
`
export const PaginationDots = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 30px;
  color: ${({color}) => color};
  font-size: 17px;
  user-select: none;
`

export const PaginationBtnPreviousNext = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 30px;
  background-color: transparent;
  color: ${({color, enabled}) => enabled ? color : "#DDD"};
  font-size: 17px;
  cursor: ${({enabled}) => enabled ? "pointer" : "not-allowed"};
  transition: 0.2s;
  &:hover {
    background-color: ${({color, enabled}) => enabled ? color : "transparent"};
    color:  ${({enabled}) => enabled ? "#FFF" : "#DDD"};;
  }
`

export const PaginationBtnContainer = styled.div `
  display: flex;
  width: ${({width}) => width};
  height: 100%;
  flex-direction: row;
  column-gap: 5px;
  justify-content: ${({justifyContent}) => justifyContent};
  align-items: center;
`